import React from 'react';
import {connect} from "trim-redux";
import {JSONEditor} from 'react-json-editor-viewer';
import Grid from "@material-ui/core/Grid/Grid";
import Container from "@material-ui/core/Container/Container";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {Translate} from "../../../../config/Translate";
import AppCard from "../../../components/layouts/components/AppCard";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import Alert from "@material-ui/lab/Alert/Alert";
import Fab from "@material-ui/core/Fab/Fab";
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import LanguageChooser from "../../../components/fields/LanguageChooser";
import SubTitle from "../../../components/elements/SubTitle";
import AppCardLoader from "../../../components/Skeletons/AppCardLoader";
class TranslateFront extends React.Component {
    classes = this.props.classes;
    state = {
        data: null,
        language: 'en',
        loading:true
    }
    componentDidMount(){
        this.loadData();
    }
    onJsonChange(key, value, parent, data){
        this.setState({
            data
        })
    }
    async loadData(){
        let {language} = this.state;
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/jsons/translate_back/${language}`, config)
            .then(response => {
                let data = response.data;
                this.setState({
                    data,
                    loading:false
                })

            }).catch(error => {
                console.log(error.response)
            })
    }
    async handleSave(){
        let data = new FormData();
        data.append('lang', this.state.language);
        data.append('data', JSON.stringify(this.state.data));
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/settings/changeBackTranslate`, data, config)
            .then(response => {

                this.props.enqueueSnackbar(Translate.allChangesSaved, {
                    variant: 'success',
                });
                window.location.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
            });
    }
   async changeLang(lang){
        await this.setState({
            language:lang,
            loading:true,
        })
        await this.loadData()
    }
    render(){
        let {data,loading} = this.state;
        console.log(data);
        return(
            <>
                <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.translateFront}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <AppCard
                                title={ Translate.translateFront}
                                action={
                                    <BreadCrumbs singleLevel firstText={Translate.translateFront}/>
                                }>
                                {
                                    loading  ?
                                        <AppCardLoaderFields/> :
                                        <Container maxWidth="xl">
                                            <Grid container spacing={2} direction="row" justifyContent="space-between">
                                                <Grid item xs={12}>
                                                    <Alert severity="warning">{Translate.translateFrontDesc}</Alert>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <SubTitle align="left"> {Translate.YouAreChangingThisLanguage}: <span className="current_language">{this.state.language}</span></SubTitle>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <LanguageChooser handleLanguage={(lang) => this.changeLang(lang)} init={this.state.language}/>
                                                </Grid>
                                                <Grid item xs={12} className="jsonEditor">
                                                    <JSONEditor
                                                        data={data}
                                                        onChange={this.onJsonChange.bind(this)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Container>
                                }
                            </AppCard>
                        </Grid>
                    </Grid>
                </AppAnimate>
                <Fab
                    variant="extended"
                    color="primary"
                    onClick={this.handleSave.bind(this)}
                    className={this.classes.fab}
                >
                    <SaveRoundedIcon style={{marginRight:5}}/>
                    {Translate.save}
                </Fab>
            </>

        )


    }
}
const mstp = state => ({
    locale: state.locale,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(TranslateFront))));